/* SOULTENTIC Desktop Lightbox + Cursor Zoom (Horizon)
   File: assets/soultentic-lightbox.js */

(() => {
  const DESKTOP_MIN = 750;
  const onDesktop = () => window.matchMedia(`(min-width:${DESKTOP_MIN}px)`).matches;

  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Try to find current main product image element on Horizon PDP
  function findPrimaryImageEl() {
    // Common Horizon/Dawn-like selectors
    return (
      qs('media-gallery .product-media-container img') ||
      qs('.product-media-container img') ||
      qs('slideshow-slide[aria-hidden="false"] img') ||
      qs('slideshow-slide img')
    );
  }

  // Collect thumbnails from page (desktop + any dialog list if present)
  function collectThumbSrcs() {
    const thumbs = new Set();

    // Common thumb containers
    qsa('.slideshow-controls__thumbnails img').forEach(img => thumbs.add(img.currentSrc || img.src));
    qsa('.dialog-thumbnails-list__thumbnail img').forEach(img => thumbs.add(img.currentSrc || img.src));
    qsa('[data-media-id] img').forEach(img => thumbs.add(img.currentSrc || img.src));

    // Fallback: collect all product media images in gallery
    qsa('media-gallery img').forEach(img => thumbs.add(img.currentSrc || img.src));

    // Remove empties
    return Array.from(thumbs).filter(Boolean);
  }

  // Build lightbox DOM once
  function ensureLightbox() {
    let root = qs('.stx-lightbox');
    if (root) return root;

    root = document.createElement('div');
    root.className = 'stx-lightbox';
    root.innerHTML = `
      <div class="stx-lightbox__backdrop" data-stx-close></div>
      <div class="stx-lightbox__panel" role="dialog" aria-modal="true">
        <div class="stx-lightbox__topbar">
          <button class="stx-lightbox__close" type="button" aria-label="Close" data-stx-close>×</button>
        </div>

        <div class="stx-lightbox__stage">
          <img class="stx-lightbox__img" alt="" />
        </div>

        <div class="stx-lightbox__thumbs" aria-label="Gallery thumbnails"></div>
      </div>
    `;
    document.body.appendChild(root);
    return root;
  }

  function openLightbox(startSrc) {
    const root = ensureLightbox();
    const img = qs('.stx-lightbox__img', root);
    const thumbsWrap = qs('.stx-lightbox__thumbs', root);

    // Reset state
    root.removeAttribute('zoomed');
    root.removeAttribute('dragging');
    root.style.setProperty('--zoom', '1');
    root.style.setProperty('--pan-x', '0px');
    root.style.setProperty('--pan-y', '0px');
    root.style.setProperty('--ox', '50%');
    root.style.setProperty('--oy', '50%');

    // Fill thumbs
    thumbsWrap.innerHTML = '';
    const srcs = collectThumbSrcs();
    const unique = srcs.length ? srcs : (startSrc ? [startSrc] : []);
    const pick = (src) => {
      img.src = src;
      qsa('.stx-thumb', thumbsWrap).forEach(t => t.removeAttribute('active'));
      const active = qsa('.stx-thumb', thumbsWrap).find(t => t.dataset.src === src);
      if (active) active.setAttribute('active', '');
    };

    unique.forEach((src) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'stx-thumb';
      b.dataset.src = src;
      b.innerHTML = `<img src="${src}" alt="" loading="lazy" />`;
      b.addEventListener('click', () => pick(src));
      thumbsWrap.appendChild(b);
    });

    // Start image
    if (startSrc) pick(startSrc);
    else if (unique[0]) pick(unique[0]);

    // Open
    root.setAttribute('open', '');
    document.documentElement.setAttribute('scroll-lock', '');
    document.body.style.overflow = 'hidden';

    // Close handlers
    qsa('[data-stx-close]', root).forEach(el => {
      el.addEventListener('click', () => closeLightbox(), { once: true });
    });

    // ESC close
    const onKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', onKey, { once: true });

    // Zoom behavior
    attachZoomBehavior(root);
  }

  function closeLightbox() {
    const root = qs('.stx-lightbox');
    if (!root) return;
    root.removeAttribute('open');
    root.removeAttribute('zoomed');
    root.removeAttribute('dragging');
    document.documentElement.removeAttribute('scroll-lock');
    document.body.style.overflow = '';
  }

  function attachZoomBehavior(root) {
    const stage = qs('.stx-lightbox__stage', root);
    const img = qs('.stx-lightbox__img', root);

    let zoomed = false;
    let dragging = false;
    let startX = 0, startY = 0;
    let panX = 0, panY = 0;

    const setZoom = (z) => {
      root.style.setProperty('--zoom', String(z));
      img.style.transform = `translate(${panX}px, ${panY}px) scale(${z})`;
    };

    const setOriginFromEvent = (e) => {
      const r = stage.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      root.style.setProperty('--ox', `${x}%`);
      root.style.setProperty('--oy', `${y}%`);
    };

    // Hover zoom follows cursor (only when zoomed OR when hovering for preview)
    stage.addEventListener('mousemove', (e) => {
      setOriginFromEvent(e);
      // If not zoomed, keep at 1 (so it just behaves normal)
      // If zoomed, it follows cursor via transform-origin
    });

    // Click toggles zoom lock
    stage.addEventListener('click', (e) => {
      // Don’t trigger when dragging ends
      if (dragging) return;

      zoomed = !zoomed;
      if (zoomed) {
        root.setAttribute('zoomed', '');
        panX = 0; panY = 0;
        setOriginFromEvent(e);
        setZoom(2); // zoom level (change to 2.2 if you want stronger)
      } else {
        root.removeAttribute('zoomed');
        panX = 0; panY = 0;
        setZoom(1);
      }
    });

    // Drag to pan when zoomed
    stage.addEventListener('mousedown', (e) => {
      if (!zoomed) return;
      dragging = true;
      root.setAttribute('dragging', '');
      startX = e.clientX - panX;
      startY = e.clientY - panY;
      e.preventDefault();
    });

    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      panX = e.clientX - startX;
      panY = e.clientY - startY;
      setZoom(2);
    });

    window.addEventListener('mouseup', () => {
      if (!dragging) return;
      dragging = false;
      root.removeAttribute('dragging');
    });

    // Wheel to zoom in/out (optional but useful)
    stage.addEventListener('wheel', (e) => {
      if (!zoomed) return;
      e.preventDefault();
      const current = parseFloat(root.style.getPropertyValue('--zoom')) || 2;
      const next = Math.min(3, Math.max(1.2, current + (e.deltaY > 0 ? -0.15 : 0.15)));
      setZoom(next);
    }, { passive: false });
  }

  // Intercept product image clicks and open our lightbox
  function bind() {
    if (!onDesktop()) return;

    // Do not bind multiple times
    if (window.__stxLightboxBound) return;
    window.__stxLightboxBound = true;

    const handler = (e) => {
      if (!onDesktop()) return;

      // Find if click is on a product media image
      const img = e.target.closest('.product-media-container img, media-gallery img, slideshow-slide img');
      if (!img) return;

      // Prevent theme zoom dialog
      e.preventDefault();
      e.stopPropagation();

      openLightbox(img.currentSrc || img.src);
    };

    // Capture phase to beat theme handlers
    document.addEventListener('click', handler, true);
  }

  // Shopify can re-render sections; bind again safely
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);

  // If theme uses dynamic navigation
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') bind();
  });
})();
